export const queryKeys = {
  user: {
    me: ['user', 'me'] as const,
  },
  projects: {
    all: ['projects'] as const,
    active: ['projects', 'active'] as const,
    dashboard: (id: string) => ['projects', id, 'dashboard'] as const,
    analytics: (id: string) => ['projects', id, 'analytics'] as const,
    budget: (id: string) => ['projects', id, 'budget'] as const,
    weeklyReport: (id: string) => ['projects', id, 'weekly-report'] as const,
  },
  stages: {
    all: (projectId: string) => ['stages', projectId] as const,
    items: (stageId: string) => ['stages', 'items', stageId] as const,
    templates: ['stages', 'templates'] as const,
    kanban: (projectId: string) => ['kanban', projectId] as const,
  },
  expenses: {
    all: (projectId: string, filters: object) => ['expenses', projectId, filters] as const,
  },
  announcements: {
    active: ['announcements', 'active'] as const,
    all: ['announcements', 'all'] as const,
  },
  reports: {
    byProject: (projectId: string) => ['reports', projectId] as const,
    unreadCount: (projectId: string) => ['reports', projectId, 'unread-count'] as const,
  },
  attachments: {
    /** Общий корень — одной инвалидацией покрывает и byProject, и byExpense. */
    root: (projectId: string) => ['attachments', projectId] as const,
    byProject: (projectId: string, kind: string) => ['attachments', projectId, 'kind', kind] as const,
    byExpense: (projectId: string, expenseId: string) => ['attachments', projectId, 'expense', expenseId] as const,
  },
  floorPlans: {
    all: (projectId: string) => ['floor-plans', projectId] as const,
    detail: (projectId: string, planId: string) => ['floor-plans', projectId, planId] as const,
  },
};
